import * as Actions from 'store/actions/app/operations_monitoring.actions'

const initialState = {
  loading_sales_monitoring: false,
  sales_monitoring: {
    sales: [],
    sold_items: [],
    services_performed: [],
    code_totals: {},
    total_sales: 0,
    total_void_sales: 0,
    total_net_sales: 0,
    sales_count: 0,
    total_utility: 0,
    product_utility: 0,
    service_utility: 0,
    total_credit_sales: 0,
  },

  loading_credits_monitoring: false,
  credits_monitoring: {
    credits: [],
    payments: [],
    total_credits: 0,
    total_pending: 0,
    total_overdue: 0,
    total_paid: 0,
    customers_in_default: 0,
    aging_buckets: {},
    credits_by_status: {},
    top_customers: [],
    trend_data: [],
    payment_trend_data: [],
  },

  loading_general_monitoring: false,
  general_monitoring: {
    total_sales: 0,
    total_tax: 0,
    tax_rate: 0,
    total_credit_sales: 0,
    net_cash_sales: 0,
    total_income: 0,
    total_client_payments: 0,
    total_expenses: 0,
    total_supplier_payments: 0,
    final_balance: 0,
    total_customer_balance: 0,
    total_supplier_balance: 0,
  },
  loading_sales_by_seller: false,
  sales_by_seller: [],
  loading_sales_by_month: false,
  sales_by_month: [],
  loading_global_customer_balances_detail: false,
  global_customer_balances_detail: [],
  loading_global_supplier_balances_detail: false,
  global_supplier_balances_detail: [],
  
  loading_sales_detail: false,
  sales_detail: {
    items: [],
    total: 0,
    totalAmount: 0,
  },
}

const operationsMonitoringReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SALES_MONITORING: {
      return {
        ...state,
        loading_sales_monitoring: action.payload.loading ?? state.loading_sales_monitoring,
        sales_monitoring: action.payload.data ?? state.sales_monitoring,
      }
    }
    case Actions.GET_CREDITS_MONITORING: {
      return {
        ...state,
        loading_credits_monitoring: action.payload.loading ?? state.loading_credits_monitoring,
        credits_monitoring: action.payload.data ?? state.credits_monitoring,
      }
    }
    case Actions.GET_GENERAL_MONITORING: {
      return {
        ...state,
        loading_general_monitoring: action.payload.loading ?? state.loading_general_monitoring,
        general_monitoring: action.payload.data ?? state.general_monitoring,
      }
    }
    case Actions.GET_SALES_BY_SELLER: {
      return {
        ...state,
        loading_sales_by_seller: action.payload.loading ?? state.loading_sales_by_seller,
        sales_by_seller: action.payload.data ?? state.sales_by_seller,
      }
    }
    case Actions.GET_SALES_BY_MONTH: {
      return {
        ...state,
        loading_sales_by_month: action.payload.loading ?? state.loading_sales_by_month,
        sales_by_month: action.payload.data ?? state.sales_by_month,
      }
    }
    case Actions.GET_GLOBAL_CUSTOMER_BALANCES_DETAIL: {
      return {
        ...state,
        loading_global_customer_balances_detail: action.payload.loading ?? state.loading_global_customer_balances_detail,
        global_customer_balances_detail: action.payload.data ?? state.global_customer_balances_detail,
      }
    }
    case Actions.GET_GLOBAL_SUPPLIER_BALANCES_DETAIL: {
      return {
        ...state,
        loading_global_supplier_balances_detail: action.payload.loading ?? state.loading_global_supplier_balances_detail,
        global_supplier_balances_detail: action.payload.data ?? state.global_supplier_balances_detail,
      }
    }
    case Actions.GET_SALES_DETAIL: {
      return {
        ...state,
        loading_sales_detail: action.payload.loading ?? state.loading_sales_detail,
        sales_detail: action.payload.data ?? state.sales_detail,
      }
    }
    default: {
      return state
    }
  }
}

export default operationsMonitoringReducer
